module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD0SURBVDhPlVMBksQgCNOd/Zf+rPoz+zIuAXG1dW+6mWEQhBixjSISHLXWT9BxHEfsyz1IQCulSGtNw9kz7zU7UwU8OeccUsrhPNvNg6gft0LVkaCf8hNKCbyuvIzLEXHiSUVqMUb1np/9AMiGgunOekH1KLHcdTamYCG4NcNYvCP5cgUTxx36Brk5JaaBsgzWcSO4NtM75tdxLAR8Sg5tbmYO8nWf87wqeHevMOb+7mhkxGaS5ExtRMT7Z9RYNAhq9acxef1QgAQIBLNACWaJnNcCfdi6/N/QqYVujHRp+Se2IxmbT20lCbL8zk+BT1ybRCT+AdDVkezzBom5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/EXPLORER_16.png
// module id = 59
// module chunks = 0